import React from 'react';
import { createRoot } from 'react-dom/client';
import Campaign from './campaign/app';
const rootElement = document.getElementById('campaign');
if(rootElement){
    const campaign_id = rootElement.dataset.campaignid
    const league_id = rootElement.dataset.leagueid
    const sky_ad = rootElement.dataset.skyad
    const root = createRoot(rootElement);
    root.render(
        <Campaign 
            campaign_id={campaign_id ?? ''}
            league_id={league_id ?? '8'}
            ad_url={sky_ad}
        />
    )
}
